/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useQuery } from "@tanstack/react-query";
import InquiryToCustomer from "@/src/types/Entities/InquiryToCustomer";
import { fetchCollection, queryKeys } from "@/src/services/reactQuery/reactQueryService";

const inquiryToCustomerApiUri = "/inquiry_to_customers";

type InquiryToCustomerFilters = {
  identifier?: string;
  productId?: number;
  calendlyEvent?: string;
  status?: InquiryToCustomer["status"];
} & Partial<Record<`status[${number}]`, InquiryToCustomer["status"]>>;

export const useInquiryToCustomers = (filters: InquiryToCustomerFilters = {}, shouldFetchInquiries = true) => {
  return useQuery<InquiryToCustomer[]>({
    queryKey: queryKeys.collection(inquiryToCustomerApiUri, filters),
    queryFn: () => fetchCollection(inquiryToCustomerApiUri, filters),
    enabled: shouldFetchInquiries,
  });
};
